"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProcessStatus = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_components_1 = require("@codametrix/ui-components");
// svgs
var hourGlass_svg_1 = __importDefault(require("../../assets/hourGlass.svg"));
var banSign_svg_1 = __importDefault(require("../../assets/banSign.svg"));
var verdigris_1 = require("@codametrix/verdigris");
var ProcessStatus = function (props) {
    var benchEditable = props.benchEditable;
    if (benchEditable.waiting) {
        return ((0, jsx_runtime_1.jsx)(ui_components_1.Card, __assign({ className: "accelerate-process-status" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "pre-coding" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "waiting-icon" }, { children: (0, jsx_runtime_1.jsx)("img", { src: hourGlass_svg_1["default"] }) })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "text-info" }, { children: "Collecting information. Please check back again." }))] })) })));
    }
    else if (benchEditable.submitted) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "accelerate-process-status" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "post-coding" }, { children: [(0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Check_Circle, iconClass: "status-icon", titleText: "Case is coded." }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "status-text" }, { children: "This case has been coded." }))] })), ' '] })));
    }
    else if (benchEditable.cancelled) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "accelerate-process-status" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "post-coding" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "status-icon" }, { children: (0, jsx_runtime_1.jsx)("img", { src: banSign_svg_1["default"], style: { width: '1rem', marginTop: '2px' } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "status-text" }, { children: "This case is cancelled and will not be sent to billing." }))] })), ' '] })));
    }
    else {
        return (0, jsx_runtime_1.jsx)("span", { className: "empty-process-status" });
    }
};
exports.ProcessStatus = ProcessStatus;
//# sourceMappingURL=process-status.js.map